<template>
  <div :style="`height:${height};width:${width};overflow-y:${overflow}`"
       class="progress">
    <div class="flex"
         v-for='(item,index) in copySeries'
         :key="index"
         :style="`font-size:${10*$store.state.ratio.hole}px; margin-top:${5*$store.state.ratio.hole}px`">
      <div class="flex1 name">{{item.name}}</div>
      <div class="flex2">
        <el-progress :percentage="item.copyValue"
                     :format="format"
                     :color='item.color'
                     :stroke-width="6*$store.state.ratio.hole">
        </el-progress>
      </div>
      <div class="flex3"
           :style="`right:${50*$store.state.ratio.hole}px`">
        {{item.value}}
      </div>
    </div>

  </div>
</template>
<script>

export default {
  props: ['height', 'width', 'series'],
  data () {
    return {
      overflow: 'hidden',
      max: 1000,
      copySeries: []    };
  },
  watch: {
    series: {
      handler: function () {
        this.handleSeries()
      },

    }
  },
  mounted () {
    this.handleSeries()
  },
  methods: {
    format (percentage) {
      // return Math.ceil(percentage * this.max / 100);
      return
    },
    handleSeries () {
      this.max = this.series[0].value
      this.copySeries = JSON.parse(JSON.stringify(this.series))
      this.copySeries.forEach(item => {
        item.copyValue = (item.value / this.max) * 100
        if (item.copyValue >= 100) {
          item.color = 'rgb(243,133,83)'
        } if (item.copyValue < 100 && item.copyValue >= 80) {
          item.color = 'rgb(231,238,54)'
        } if (item.copyValue < 80 && item.copyValue >= 60) {
          item.color = 'rgb(72,242,82)'
        } if (item.copyValue < 60 && item.copyValue >= 40) {
          item.color = 'rgb(16,253,247)'
        }
        if (item.copyValue < 40 && item.copyValue >= 20) {
          item.color = 'rgb(84,129,251)'
        } if (item.copyValue < 20 && item.copyValue >= 0) {
          item.color = 'rgb(243,33,183)'
        }
      })

    }
  }
}
</script>
<style lang="scss" scope>
.flex {
  display: flex;
  .flex1 {
    flex: 1;
    text-align: center;
  }
  .flex2 {
    flex: 3;
  }
  .flex3 {
    position: absolute;
  }
}
::-webkit-scrollbar {
  width: 10px;

  background-color: rgba(12, 29, 45, 0.75);
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(12, 29, 45, 0.75);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}
</style>